import React from 'react';
import { useSelector } from 'react-redux';
import Filters from '../../components/Filters';
import HeadingSection from '../../components/HeadingSection';
import useAgency from '../../hooks/useAgency';
import useAgencyDefaults from '../../hooks/useAgencyDefaults';

const AnalyticsLayout = ({
  title,
  subTitle,
  backTo,
  backToLastPath,
  tooltip,
  metricType,
  children,
  ...props
}) => {
  const { agencyId } = useSelector(({ user }) => user);
  const {
    status: { availability },
    isLoading,
  } = useAgency({ id: agencyId });

  const { agencyPeriods } = useAgencyDefaults();

  return (
    <main className="analytics-layout">
      <HeadingSection
        title={title}
        backTo={backTo}
        backToLastPath={backToLastPath}
        subTitle={subTitle}
        tooltip={tooltip}
        {...props}
      >
        <Filters
          isLoading={isLoading}
          availability={availability[metricType]}
          isPeriodSingleSelect={true}
          agencyPeriods={agencyPeriods}
        />
      </HeadingSection>
      {children}
    </main>
  );
};

export default AnalyticsLayout;
